/* Configurateur parasol Glatz — table de compatibilité (listes de prix Glatz 2026, 21.10.2026). Générée par le script du chantier, ne pas éditer à la main. */
window.CFGP_DATA={v:'2026-10-21',m:{
alexo:{
n:'ALEXO',
h:'glatz-parasol-alexo',
g:'centre',
pro:0,
offre:0,
sz:[['d200',30,'40 x 40','20 km/h (Bft 4)'],['d220',30,'40 x 40','20 km/h (Bft 4)']],
ss:'100810 101000 101001 109432 109480 109486 109487 109529 111016 111116 200135 205000 205100 205105 205400 563000 563100 609983',
hs:[['609983']],
a:[['563000','L'],['563100','L']],
pz:[],
par:[]
},
smart:{
n:'SMART',
h:'glatz-parasol-smart',
g:'centre',
pro:0,
offre:0,
sz:[['d200',30,'40 x 40',''],['d220',30,'40 x 40',''],['d250',40,'50 x 50',''],['d300',40,'60 x 60',''],['200x200',40,'40 x 40',''],['240x240',40,'50 x 50',''],['210x150',30,'40 x 40',''],['250x200',40,'50 x 50','']],
ss:'100810 101000 101001 109445 109465 109467 109480 109486 109487 109529 111016 111116 113200 113310 113320 201710 201920 201930 205000 205400 206100 252005',
hs:[['609980']],
a:[['563000','L'],['563100','L']],
pz:[],
par:[]
},
alusmart:{
n:'ALU-SMART',
h:'glatz-parasol-alu-smart',
g:'centre',
pro:0,
offre:0,
sz:[['d200',30,'40 x 40','75 km/h (Bft 9)'],['d250',40,'50 x 50','50 km/h (Bft 7)'],['d300',40,'60 x 60','35 km/h (Bft 5)'],['200x200',40,'40 x 40','50 km/h (Bft 7)'],['240x240',40,'50 x 50','40 km/h (Bft 6)'],['210x150',30,'40 x 40','55 km/h (Bft 7)'],['250x200',40,'50 x 50','40 km/h (Bft 6)']],
ss:'100810 101000 101001 109432 109480 109486 109487 109529 111016 111116 112116 113200 113280 113310 113320 201010 201100 205000 205400 206100 206210 252005 563000 563100 609974 609980',
hs:[['609980']],
a:[['563000','L'],['563100','L']],
pz:[],
par:[]
},
twist:{
n:'TWIST',
h:'glatz-parasol-twist',
g:'centre',
pro:0,
offre:0,
sz:[['d270',40,'50 x 50',''],['d300',40,'60 x 60',''],['d330',55,'60 x 60',''],['240x240',40,'50 x 50',''],['210x150',30,'50 x 50',''],['250x200',40,'50 x 50','']],
ss:'100810 100910 101000 101001 109445 109447 109465 109467 109480 109486 109487 109529 111016 111116 111216 113200 113310 113320 201610 201820 201830 205000 205400 206100 902716 902730',
hs:[['609980']],
a:[['563000','L'],['563100','L']],
pz:[],
par:[]
},
alutwist:{
n:'ALU-TWIST',
h:'glatz-parasol-alu-twist-easy',
g:'centre',
pro:0,
offre:0,
sz:[['d300',40,'60 x 60','50 km/h (Bft 7)'],['d330',55,'60 x 60','45 km/h (Bft 6)'],['240x240',40,'50 x 50','45 km/h (Bft 6)'],['250x200',40,'50 x 50','45 km/h (Bft 6)']],
ss:'100810 100910 101000 101001 109432 109434 109447 109486 109487 109529 111116 111216 112116 112216 113200 113280 113310 113320 201010 201100 205000 205400 206100 206210 252005 563000 563100 609974 609980',
hs:[['609980']],
a:[['563000','L'],['563100','L']],
pz:[],
par:[]
},
piana:{
n:'VITA Piana',
h:'glatz-parasol-vita-piana',
g:'centre',
pro:0,
offre:0,
sz:[['d220',30,'40 x 40','65 km/h (Bft 8)'],['d250',40,'50 x 50','50 km/h (Bft 7)'],['d300',40,'60 x 60','35 km/h (Bft 5)'],['200x200',40,'40 x 40','50 km/h (Bft 7)'],['240x240',40,'50 x 50','40 km/h (Bft 6)'],['210x150',30,'40 x 40','55 km/h (Bft 7)'],['250x200',40,'50 x 50','40 km/h (Bft 6)']],
ss:'100810 101000 101001 109432 109480 109486 109487 111016 111116 112116 113200 113280 113320 114340 201710 201920 201930 205000 205400 206100 252005 563000 563100 609974 609980',
hs:[['609980']],
a:[['563000','L'],['563100','L']],
pz:[],
par:[]
},
torna:{
n:'VITA Torna',
h:'glatz-parasol-vita®-torna',
g:'centre',
pro:0,
offre:0,
sz:[['d270',40,'50 x 50','55 km/h (Bft 7)'],['d300',40,'60 x 60','50 km/h (Bft 7)'],['d330',55,'60 x 60','45 km/h (Bft 6)'],['240x240',40,'50 x 50','45 km/h (Bft 6)'],['210x150',30,'50 x 50','55 km/h (Bft 7)'],['250x200',40,'50 x 50','45 km/h (Bft 6)']],
ss:'100810 100910 101000 101001 109432 109434 109480 109486 109487 111016 111116 111216 112116 112216 113200 113280 113320 114340 201610 201820 201830 205000 205400 206100 563000 563100 609974 609980',
hs:[['609980']],
a:[['563000','L'],['563100','L']],
pz:[],
par:[]
},
piazza:{
n:'PIAZZA',
h:'glatz-parasol-piazza®',
g:'bois',
pro:0,
offre:0,
sz:[['d250',40,'60 x 60','75 km/h (Bft 9)'],['d300',55,'70 x 70','55 km/h (Bft 7)'],['250x250',55,'70 x 70','60 km/h (Bft 7)']],
ss:'100810 100910 101000 101001 109432 109434 109447 109486 109487 109529 111116 111216 112116 112216 113200 113280 113310 113320 200035 201210 201282 201300 205000 205400 206001 206011 206082 207001 207011 222510 226921 226930 226932 563000 563100 609800',
hs:[['609800']],
a:[['563000','L'],['563100','L']],
pz:[],
par:[]
},
teakwood:{
n:'TEAKWOOD',
h:'glatz-parasol-teakwood',
g:'bois',
pro:0,
offre:0,
sz:[['d300',40,'60 x 60','30 km/h (Bft 5)'],['d350',55,'60 x 60','30 km/h (Bft 5)'],['330x330',70,'60 x 60','30 km/h (Bft 5)']],
ss:'100810 100910 101000 101001 109432 109434 109436 109447 109486 109487 109529 111116 111216 111316 112116 112216 113200 113280 113310 113320 113400 113480 200035 201210 201282 201300 205000 206001 206011 206082 207001 207011 222510 226921 226930 226932 563000 563100 609979',
hs:[['609979']],
a:[['563000','L'],['563100','L']],
pz:[],
par:[]
},
fortero:{
n:'FORTERO Pro',
h:'glatz-parasol-fortero®-pro',
g:'centre',
pro:0,
offre:0,
sz:[['d350',90,'70 x 70','55 km/h (Bft 7)'],['300x300',90,'70 x 70','60 km/h (Bft 7)'],['350x350',120,'80 x 80','50 km/h (Bft 7)'],['300x200',70,'70 x 70','65 km/h (Bft 8)'],['350x250',90,'70 x 70','55 km/h (Bft 7)']],
ss:'100500 100617 100630 108235 109436 109438 109486 109487 109495 110500 110550 111316 111416 112416 113400 113480 113610 113620 113710 113720 200035 201210 201300 206001 206011 207001 207011 222510 226510 226908 226909 226921 226930 226932 229405 229410 563000 563100 609704 609705',
hs:[['609705','d350 300x300 300x200 350x250'],['609704','350x350']],
a:[['563000','L'],['563100','L']],
pz:[],
par:[]
},
fortello:{
n:'FORTELLO LED',
h:'glatz-parasol-fortello-led',
g:'centre',
pro:0,
offre:0,
sz:[['d400',120,'80 x 80','80 km/h (Bft 9)'],['300x300',120,'80 x 80','90 km/h (Bft 10)'],['350x350',120,'80 x 80','80 km/h (Bft 9)'],['400x400',180,'90 x 90','70 km/h (Bft 8)'],['400x300',120,'80 x 80','80 km/h (Bft 9)']],
ss:'100500 100617 100630 100717 100730 108235 108335 109438 109486 109487 109495 110500 110800 113610 113620 113710 113720 113810 113820 113910 113920 200235 207001 221800 222510 226510 226906 226907 226908 226909 226921 226930 226932 229405 229410 563000 563100 565500 609701',
hs:[['609701']],
a:[['563000','L'],['563100','L'],['565500','B']],
pz:[],
par:[]
},
sunwing:{
n:'SUNWING Casa',
h:'glatz-parasol-sunwing-casa',
g:'deporte',
pro:0,
offre:0,
sz:[['d300',90,'60 x 60','35 km/h (Bft 5)'],['d330',90,'60 x 60','30 km/h (Bft 5)'],['270x270',90,'60 x 60','30 km/h (Bft 5)'],['300x240',90,'60 x 60','35 km/h (Bft 5)']],
ss:'100500 100617 100630 108235 109436 109486 109487 110500 110550 111416 112416 113400 113480 113610 113620 113710 113720 200035 200082 201210 201282 201300 206001 206011 206082 207001 207011 222510 226510 226908 226909 226921 226930 226932 229405 563000 563100 609702 609703',
hs:[['609702']],
a:[['563000','L'],['563100','L']],
pz:[],
par:[]
},
sombrano:{
n:'SOMBRANO S+',
h:'glatz-parasol-sombrano-s-easy',
g:'deporte',
pro:0,
offre:0,
sz:[['d350',120,'70 x 70','45 km/h (Bft 6)'],['d400',180,'80 x 80','35 km/h (Bft 5)'],['300x300',120,'70 x 70','45 km/h (Bft 6)'],['350x350',180,'80 x 80','35 km/h (Bft 5)'],['400x300',180,'80 x 80','35 km/h (Bft 5)']],
ss:'100500 100617 100630 100717 100730 108235 108335 109438 109486 109487 109495 110500 110800 113610 113620 113710 113720 113810 113820 113910 113920 221492 221493 221502 221503 222510 226510 226906 226907 226908 226909 226921 226930 226932 229405 229410 563000 563100',
hs:[['221492','d350 300x300'],['221502','d400 400x300 350x350']],
a:[['563000','L'],['563100','L']],
pz:[],
par:[]
},
pendalex:{
n:'PENDALEX P+',
h:'glatz-parasol-pendalex-p',
g:'deporte',
pro:0,
offre:0,
sz:[['d300',90,'60 x 60','20 km/h (Bft 4)'],['d325',120,'70 x 70','20 km/h (Bft 4)'],['d350',120,'70 x 70','20 km/h (Bft 4)'],['285x230',90,'60 x 60','20 km/h (Bft 4)']],
ss:'100500 100617 100630 108235 109436 109438 109486 109487 109495 110500 110550 111416 112416 113400 113480 113610 113620 113710 113720 200235 201400 201500 206020 206030 206040 206050 207001 207011 222510 226510 226908 226909 226921 226930 226932 229405 229410 563000 563100 609931',
hs:[['609931']],
a:[['563000','L'],['563100','L']],
pz:[],
par:[]
},
fortano:{
n:'FORTANO',
h:'glatz-parasol-fortano',
g:'deporte',
pro:0,
offre:0,
sz:[['300x300',180,'70 x 70','55 km/h (Bft 7)'],['400x300',180,'80 x 80','45 km/h (Bft 6)']],
ss:'100500 100717 100730 108335 110800 113810 113820 113910 113920 220940 220950 220960 220970 221502 222510 226510 226906 226907 226921 226930 226932 229405 229410 563000 563100',
hs:[['221502']],
a:[['563000','L'],['563100','L']],
pz:[],
par:[]
},
sfera:{
n:'VITA Sfera',
h:'glatz-parasol-vita®-sfera',
g:'deporte',
pro:0,
offre:0,
sz:[['d375',180,'60 x 60','45 km/h (Bft 6)'],['300x300',180,'60 x 60','50 km/h (Bft 7)'],['350x350',180,'60 x 60','40 km/h (Bft 6)'],['400x300',180,'60 x 60','40 km/h (Bft 6)']],
ss:'100500 100717 100730 108335 110800 113820 113830 113920 113940 221504 221505 221506 222510 226510 226906 226907 226921 226930 226932 229405 229410 563000 563100',
hs:[['221504','d375'],['221505','300x300'],['221506','350x350 400x300']],
a:[['563000','L'],['563100','L']],
pz:[],
par:[]
},
ambiente:{
n:'AMBIENTE Nova',
h:'glatz-ambiente-nova-parasol-professionnel',
g:'pro',
pro:1,
offre:0,
sz:[['d400',240,'80 x 80','45 km/h (Bft 6)'],['d500',310,'100 x 100','35 km/h (Bft 5)'],['350x350',240,'80 x 80','40 km/h (Bft 6)'],['400x400',310,'100 x 100','35 km/h (Bft 5)'],['400x300',240,'80 x 80','45 km/h (Bft 6)'],['450x350',310,'100 x 100','35 km/h (Bft 5)']],
ss:'222510 226510 226921 226930 226932 226945 226950 226952 227080 227090 227417 227430 227517 227530 229405 229410 555310 561300 563000 563100 609813 609814',
hs:[['609813','400x400 450x350 d400 d500'],['609814','350x350 400x300']],
a:[['555310','T'],['563000','L'],['563100','L']],
pz:[['5612XX',1245,'LED blanc chaud, direct, indirect et sur mât, luminosité réglable, commande Pz200 incl.'],['561300',1595,'Motorisation pour Ambiente Nova, commande Pz200 incl.'],['5613XX',2475,'LED blanc chaud et motorisation pour Ambiente Nova, commande Pz200 incl.']],
par:[]
},
castello:{
n:'CASTELLO Pro',
h:'glatz-castello-pro-parasol-professionnel',
g:'pro',
pro:1,
offre:0,
sz:[['d350',180,'80 x 80','100 (10)'],['d400',180,'90 x 90','90 (10)'],['d450',180,'90 x 90','75 (9)'],['d500',240,'100 x 100','65 (8)'],['d550',310,'100 x 100','60 (7)'],['d600',310,'100 x 100','55 (7)'],['300x300',180,'90 x 90','100 (10)'],['350x350',240,'90 x 90','85 (9)'],['400x400',240,'100 x 100','75 (9)'],['450x450',310,'100 x 100','65 (8)'],['500x500',310,'110 x 110','60 (7)'],['350x300',180,'90 x 90','90 (10)'],['400x300',180,'90 x 90','80 (9)'],['450x350',240,'100 x 100','75 (9)'],['500x400',310,'100 x 100','65 (8)'],['550x450',310,'110 x 110','60 (7)']],
ss:'100500 100717 100730 108335 110800 113810 113820 113910 113920 222510 226510 226906 226907 226921 226930 226932 226945 226950 226952 227300 22730019 227417 227430 227517 227530 555305 555320 562200 56220019 562201 563000 563100 570600 570700 609715 609725 900300 900310 900340 906100',
hs:[['609715','300x300 350x300 350x350 400x300 400x400 450x350 d350 d400 d450 d500 d550'],['609725','450x450 500x400 500x500 550x450 d600']],
a:[['570600','C'],['900340','S','300x300 d350 d400'],['900300','S','350x300 350x350 400x300 400x400 450x350 450x450 d450 d500 d550'],['900310','S','500x400 500x500 550x450 d600'],['555320','T'],['555305','T'],['563000','L'],['563100','L']],
pz:[['5620XX',1245,'LED RGBW, directe et indirecte, 1 × 230 V, telegris'],['5620XX19',1245,'LED RGBW, directe et indirecte, 1 × 230 V, anthracite'],['562200',1245,'chauffages radiants, 3 × 400 V, telegris'],['56220019',1245,'chauffages radiants, 3 × 400 V, anthracite'],['5621XX',1615,'LED RGBW et chauffages radiants, 3 × 400 V, telegris'],['5621XX19',1615,'LED RGBW et chauffages radiants, 3 × 400 V, anthracite']],
par:[['759510XXX',555,'300 × 215 cm, CAS 5 3/-'],['759512XXX',595,'350 × 215 cm, CAS 5 3/-'],['759514XXX',645,'400 × 215 cm, CAS 5 3/-'],['759516XXX',655,'450 × 215 cm, CAS 5 3/-'],['759518XXX',735,'500 × 215 cm, CAS 5 3/-'],['759520XXX',895,'550 × 215 cm, CAS 5 3/-']]
},
style:{
n:'PALAZZO Style',
h:'glatz-palazzo-style-parasol-professionnel',
g:'pro',
pro:1,
offre:1,
sz:[['d300',180,'90 x 90','120 (12)'],['d350',180,'90 x 90','115 (11)'],['d400',180,'90 x 90','90 (10)'],['d450',180,'100 x 100','75 (9)'],['d500',240,'100 x 100','70 (8)'],['d550',310,'110 x 110','65 (8)'],['d600',310,'110 x 110','60 (7)'],['300x300',180,'90 x 90','115 (11)'],['350x350',240,'100 x 100','95 (10)'],['400x400',240,'110 x 110','80 (9)'],['450x450',310,'110 x 110','70 (8)'],['500x500',310,'120 x 120','60 (7)'],['300x200',180,'90 x 90','115 (11)'],['300x250',180,'90 x 90','110 (11)'],['350x200',180,'90 x 90','110 (11)'],['350x250',180,'90 x 90','105 (10)'],['350x300',180,'100 x 100','95 (10)'],['400x200',180,'90 x 90','95 (10)'],['400x250',180,'90 x 90','90 (10)'],['400x300',180,'100 x 100','85 (9)'],['400x350',240,'100 x 100','80 (9)'],['450x250',180,'100 x 100','90 (10)'],['450x300',180,'100 x 100','80 (9)'],['450x350',240,'100 x 100','75 (9)'],['450x400',240,'110 x 110','70 (8)'],['500x250',180,'100 x 100','85 (9)'],['500x300',240,'100 x 100','80 (9)'],['500x350',240,'110 x 110','70 (8)'],['500x400',240,'110 x 110','65 (8)'],['500x450',310,'110 x 110','60 (7)']],
ss:'100500 100717 100730 108335 110800 113810 113820 113910 113920 222510 223510 225040 22504019 226000 226510 226906 226907 226921 226930 226932 226945 226950 226952 227040 22704019 227417 227430 227517 227530 229705 229707 555305 555320 564100 56410019 564200 564300 56430019 564400 56440019 570600 570700 609805 609815 609825 900300 900310 900340 906200',
hs:[['609805','300x200 300x250 350x200 400x200 400x250 d300'],['609815','300x300 350x250 350x300 350x350 400x300 400x350 450x250 450x300 450x350 500x250 500x300 d350 d400'],['609825','400x400 450x400 450x450 500x350 500x400 500x450 500x500 d450 d500 d550 d600']],
a:[['570600','C'],['900340','S','300x200 300x250 300x300 350x200 d300 d350 d400'],['900300','S','350x250 350x300 350x350 400x200 400x400 d450 d500'],['900310','S','400x250 400x300 400x350 450x250 450x300 450x350 450x400 450x450 500x250 500x300 500x350 500x400 500x450 500x500 d550 d600'],['555320','T'],['555305','T']],
pz:[['5640XX',1395,'LED RGB+W, directe et indirecte, 1 × 230 V, telegris'],['5640XX19',1395,'LED RGB+W, directe et indirecte, 1 × 230 V, anthracite'],['564100',1195,'chauffages radiants, 3 × 400 V, telegris'],['56410019',1195,'chauffages radiants, 3 × 400 V, anthracite'],['5641XX',1985,'LED RGB+W et chauffages radiants, 3 × 400 V, telegris'],['5641XX19',1985,'LED RGB+W et chauffages radiants, 3 × 400 V, anthracite'],['564300',675,'moteur, 1 × 230 V, 10 A, telegris'],['56430019',675,'moteur, 1 × 230 V, 10 A, anthracite'],['5643XX',1655,'LED RGB+W et moteur, 1 × 230 V, telegris'],['5643XX19',1655,'LED RGB+W et moteur, 1 × 230 V, anthracite'],['564400',1345,'chauffages radiants et moteur, 3 × 400V, telegris'],['56440019',1345,'chauffages radiants et moteur, 3 × 400V, anthracite'],['5644XX',2235,'LED RGB+W, chauffages radiants et moteur, 3 × 400 V, telegris'],['5644XX19',2235,'LED RGB+W, chauffages radiants et moteur, 3 × 400 V, anthracite']],
par:[['759544XXX',565,'200 × 225 cm, PzS 5 3/-'],['759546XXX',595,'250 × 225 cm, PzNS 5 3/-'],['759548XXX',645,'300 × 225 cm, PzNS 5 3/-'],['759550XXX',685,'350 × 225 cm, PzNS 5 3/-'],['759552XXX',725,'400 × 225 cm, PzNS 5 3/-'],['759554XXX',775,'450 × 225 cm, PzNS 5 3/-'],['759556XXX',795,'500 × 225 cm, PzN 5 3/-'],['759558XXX',825,'500 × 225 cm, PzN 5 4/-']]
},
noblesse:{
n:'PALAZZO Noblesse',
h:'glatz-palazzo-noblesse-parasol-professionnel',
g:'pro',
pro:1,
offre:1,
sz:[['d400|8',240,'100 x 100','110 (11)'],['d450|8',240,'100 x 100','85 (9)'],['d500|8',240,'100 x 100','80 (9)'],['d500|10',430,'110 x 110','105 (11)'],['d550|10',430,'110 x 110','90 (10)'],['d600|10',430,'110 x 110','80 (9)'],['d650|10',570,'110 x 110','75 (9)'],['d700|10',570,'120 x 120','65 (8)'],['350x350|8',310,'100 x 100','110 (11)'],['400x400|8',310,'100 x 100','90 (10)'],['400x400|12',430,'110 x 110','110 (11)'],['450x450|8',430,'110 x 110','80 (9)'],['450x450|12',570,'120 x 120','105 (11)'],['500x500|8',430,'110 x 110','70 (8)'],['500x500|12',430,'110 x 110','85 (9)'],['550x550|12',570,'120 x 120','75 (9)'],['600x600|12',570,'130 x 130','65 (8)'],['450x350|8',240,'100 x 100','85 (9)'],['450x400|8',310,'100 x 100','80 (9)'],['500x250|8',240,'100 x 100','90 (10)'],['500x300|10',310,'100 x 100','95 (10)'],['500x350|10',310,'110 x 110','90 (10)'],['500x400|8',310,'110 x 110','70 (8)'],['500x400|10',430,'110 x 110','85 (9)'],['500x450|10',430,'110 x 110','80 (9)'],['550x300|10',310,'110 x 110','90 (10)'],['550x350|10',310,'110 x 110','85 (9)'],['550x400|10',430,'110 x 110','80 (9)'],['550x450|10',430,'110 x 110','75 (9)'],['550x500|10',430,'120 x 120','70 (8)'],['600x300|10',310,'110 x 110','80 (9)'],['600x350|10',430,'110 x 110','80 (9)'],['600x400|10',430,'120 x 120','75 (9)'],['600x450|10',430,'120 x 120','70 (8)'],['600x500|10',430,'120 x 120','70 (8)'],['600x550|10',570,'120 x 120','65 (8)']],
ss:'222510 223510 225040 22504019 226000 226510 226921 226930 226932 226945 226948 226950 226952 226954 227040 22704019 227417 227430 227517 227530 229705 229707 555305 555320 564100 56410019 564200 564300 56430019 564400 56440019 570600 570700 609815 609825 609835 900300 900310 900340 906200',
hs:[['609815','350x350 500x250 500x300 d400 d450'],['609825','400x400 450x350 450x400 450x450 500x350 500x400 500x450 500x500 550x300 550x350 550x400 550x450 600x300 600x350 600x400 600x450 d500 d550 d600 d650 d700'],['609835','550x500 550x550 600x500 600x550 600x600']],
a:[['570600','C'],['900340','S','d400'],['900300','S','350x350 400x400 d450 d500'],['900310','S','450x350 450x400 450x450 500x250 500x300 500x350 500x400 500x450 500x500 550x300 550x350 550x400 550x450 550x500 550x550 600x300 600x350 600x400 600x450 600x500 600x550 600x600 d550 d600 d650 d700'],['555320','T'],['555305','T']],
pz:[['5640XX',1495,'LED RGB+W, directe et indirecte, 1 × 230 V, telegris'],['5640XX19',1495,'LED RGB+W, directe et indirecte, 1 × 230 V, anthracite'],['564100',1195,'chauffages radiants, 3 × 400 V, telegris'],['56410019',1195,'chauffages radiants, 3 × 400 V, anthracite'],['5641XX',2085,'LED RGB+W et chauffages radiants, 3 × 400 V, telegris'],['5641XX19',2085,'LED RGB+W et chauffages radiants, 3 × 400 V, anthracite'],['564300',675,'moteur, 1 × 230 V, 10 A, telegris'],['56430019',675,'moteur, 1 × 230 V, 10 A, anthracite'],['5643XX',1765,'LED RGB+W et moteur, 1 × 230 V, telegris'],['5643XX19',1765,'LED RGB+W et moteur, 1 × 230 V, anthracite'],['564400',1345,'chauffages radiants et moteur, 3 × 400V, telegris'],['56440019',1345,'chauffages radiants et moteur, 3 × 400V, anthracite'],['5644XX',2335,'LED RGB+W, chauffages radiants et moteur, 3 × 400 V, telegris'],['5644XX19',2335,'LED RGB+W, chauffages radiants et moteur, 3 × 400 V, anthracite']],
par:[['759546XXX',595,'250 × 225 cm, PzNS 5 3/-'],['759548XXX',645,'300 × 225 cm, PzNS 5 3/-'],['759550XXX',685,'350 × 225 cm, PzNS 5 3/-'],['759552XXX',725,'400 × 225 cm, PzNS 5 3/-'],['759553XXX',755,'400 × 225 cm, PzNS 5 4/-'],['759554XXX',775,'450 × 225 cm, PzNS 5 3/-'],['759555XXX',785,'450 × 225 cm, PzNS 5 4/-'],['759556XXX',795,'500 × 225 cm, PzN 5 3/-'],['759558XXX',825,'500 × 225 cm, PzN 5 4/-'],['759559XXX',845,'550 × 225 cm, PzNS 5 3/-'],['759560XXX',875,'550 × 225 cm, PzN 5 4/-'],['759562XXX',915,'600 × 225 cm, PzN 5 4/-']]
},
royal:{
n:'PALAZZO Royal',
h:'glatz-palazzo-royal-parasol-geant-professionnel',
g:'pro',
pro:1,
offre:1,
sz:[['d500|10',570,'110 x 110','120 (12)'],['d600|10',570,'120 x 120','105 (11)'],['d700|10',690,'120 x 120','80 (9)'],['d800|10',690,'130 x 130','70 (8)'],['500x500|12',570,'120 x 120','110 (11)'],['550x550|12',690,'120 x 120','100 (10)'],['600x600|12',690,'130 x 130','90 (10)'],['650x650|12',690,'140 x 140','85 (9)'],['700x700|12',690,'140 x 140','75 (9)'],['550x500|10',570,'120 x 120','85 (9)'],['600x500|10',570,'120 x 120','80 (9)'],['600x550|10',570,'130 x 130','75 (9)'],['650x400|10',570,'120 x 120','80 (9)'],['650x450|10',570,'120 x 120','75 (9)'],['650x500|10',570,'130 x 130','75 (9)'],['650x550|10',690,'130 x 130','70 (8)'],['700x350|10',570,'120 x 120','85 (9)'],['700x400|10',570,'120 x 120','80 (9)'],['700x450|10',570,'130 x 130','75 (9)'],['700x500|10',570,'130 x130','75 (9)'],['700x550|12',690,'130 x 130','70 (8)'],['700x600|12',690,'140 x 140','75 (9)'],['700x650|12',690,'140 x 140','60 (7)'],['750x450|12',570,'130 x 130','75 (9)'],['750x500|12',690,'130 x 130','70 (9)'],['800x400|10',570,'130 x 130','75 (9)'],['800x500|12',690,'140 x 140','65 (8)'],['800x600|14',690,'140 x 140','60 (7)']],
ss:'224510 225045 22504519 226001 226945 226954 226956 229701 229710 229712 555305 555320 564100 56410019 564200 564300 56430019 564400 56440019 570600 570700 609825 609835 609845 900320 900330 906300',
hs:[['609825','500x500 d500 d600'],['609835','550x500 550x550 600x500 600x550 600x600 650x400 650x450 650x500 650x550 700x350 700x400 700x450 700x500 700x550 750x450 750x500 800x400 d700 d800'],['609845','650x650 700x600 700x650 700x700 800x500 800x600']],
a:[['570600','C'],['900320','S','500x500 550x500 550x550 600x500 600x550 600x600 650x400 650x450 650x500 650x550 700x350 700x400 700x450 700x500 d500 d600 d700 d800'],['900330','S','650x650 700x550 700x600 700x650 700x700 750x450 750x500 800x400 800x500 800x600'],['555320','T'],['555305','T']],
pz:[['5640XX',1595,'LED RGB+W, directe et indirecte, 1 × 230 V, telegris'],['5640XX19',1595,'LED RGB+W, directe et indirecte, 1 × 230 V, anthracite'],['564100',1195,'chauffages radiants, 3 × 400 V, telegris'],['56410019',1195,'chauffages radiants, 3 × 400 V, anthracite'],['5641XX',2195,'LED RGB+W et chauffages radiants, 3 × 400 V, telegris'],['5641XX19',2195,'LED RGB+W et chauffages radiants, 3 × 400 V, anthracite'],['564300',675,'moteur, 1 × 230 V, 10 A, telegris'],['56430019',675,'moteur, 1 × 230 V, 10 A, anthracite'],['5643XX',1865,'LED RGB+W et moteur, 1 × 230 V, telegris'],['5643XX19',1865,'LED RGB+W et moteur, 1 × 230 V, anthracite'],['564400',1345,'chauffages radiants et moteur, 3 × 400V, telegris'],['56440019',1345,'chauffages radiants et moteur, 3 × 400V, anthracite'],['5644XX',2445,'LED RGB+W, chauffages radiants et moteur, 3 × 400 V, telegris'],['5644XX19',2445,'LED RGB+W, chauffages radiants et moteur, 3 × 400 V, anthracite']],
par:[['759565XXX',845,'350 × 245 cm, PzR 5 3/-'],['759568XXX',875,'400 × 245 cm, PzR 5 3/-'],['759566XXX',885,'450 × 245 cm, PzR 5 3/-'],['759567XXX',895,'450 × 245 cm, PzR 5 4/-'],['759569XXX',915,'500 × 245 cm, PzR 5 4/-'],['759570XXX',895,'500 × 245 cm, PzR 5 3/-'],['759572XXX',925,'550 × 245 cm, PzR 5 3/-'],['759571XXX',965,'550 × 245 cm, PzR 5 4/-'],['759574XXX',995,'600 × 245 cm, PzR 5 4/-'],['759576XXX',1075,'650 × 245 cm, PzR 5 4/-'],['759578XXX',1125,'700 × 245 cm, PzR 5 4/-'],['759579XXX',1175,'750 × 245 cm, PzR 5 4/-'],['759580XXX',1225,'800 × 245 cm, PzR 5 4/-'],['759582XXX',1245,'800 × 245 cm, PzR 5 5/-']]
}
},cat:{
'109432':['Socle en granit naturel Z, 40 kg, 50 x 50 x 8 cm, pierre naturelle, mat',165],
'109438':['Socle en granit naturel M4, 120 kg, 87 x 87 x 9.5 cm, pierre naturelle, mat',625],
'109445':['Granitsockel Z mit Rollen und ausziehbarem Handgriff, 55 × 55 × 9 cm',null],
'109465':['Granitsockel Z mit Rollen und ausziehbarem Handgriff, 45 × 45 × 8 cm',null],
'109467':['Granitsockel Z, 50 × 50 × 8 cm, Naturstein',null],
'109495':['Socle en granit naturel M4, 120 kg, 87 x 87 x 9.5 cm, pierre naturelle',625],
'109529':['Socle en béton Z, 40 kg, Ø 60 × 8.5 cm',95],
'110550':['Kit de conteneurs pour le socle à roulettes M4, 90/120 kg, 4 pièces,…',85],
'112116':['1 palette ( 20 pièces ) socle en béton Z, 40 kg, Ø 60 × 8.5 cm, béton clair',1945],
'112216':['1 palette ( 20 pièces ) socle en béton Z, 55 kg, Ø 60 × 11 cm, béton clair',2475],
'112416':['1 palette ( 10 pièces ) socle en béton Z, 90 kg, Ø 75 × 11 cm, béton clair',1925],
'113280':['1 palette ( 5 pièces ) socle à roulettes Z, 55 kg, 65 × 65 × 11 cm,…',2425],
'113480':['1 palette (5 pièces) socle à roulettes Z, 90 kg, 80 × 80 × 11 cm, béton…',3495],
'201920':['Tube de raccord BT, intégré, Ø 30 / 25 mm, cache gris soie inclus',149],
'201930':['Tube de raccord BT, intégré, Ø 30 / 25 mm, cache anthracite inclus',149],
'221493':['5 pièces, housse de protection avec baguette et fermeture éclair à…',485],
'221503':['5 pièces, housse de protection avec baguette et fermeture éclair à…',485],
'221800':['Adaptateur PX à M4',149],
'222510':['Plaque de montage M4 pour hautes isolations (50-350 mm), hauteur…',1395],
'223510':['Plaque de montage M8 pour hautes isolations (50-350 mm), hauteur…',1475],
'224510':['Plaque de montage M16 pour hautes isolations (50-350 mm), hauteur…',1825],
'22504019':['Charnière de montage M8 avec profil PzS/PzN, anthracite thermolaqué…',495],
'22504519':['Charnière de montage M16 avec profil PzR, anthracite thermolaqué (avec…',685],
'226930':['Plaque de montage M4 spéciale, pour une hauteur d’installation de…',995],
'226932':['Plaque de montage M4 spéciale, pour une hauteur d’installation de 50–149 mm',995],
'22704019':['Tube de fixation M4 avec profil PzS/PzN, anthracite thermolaqué (avec…',295],
'227090':['Adaptateur rotatif M4 vers M4, pivotant à 360° (électrique: 310°)',1245],
'22730019':['Tube de fixation M4 avec profil Castello Pro, anthracite thermolaqué…',295],
'229705':['Plaque de montage M8 spéciale, pour une hauteur d’installation de…',1115],
'229707':['Plaque de montage M8 spéciale, pour une hauteur d’installation de 50–149 mm',1115],
'229710':['Plaque de montage M16 spéciale, pour une hauteur d’installation de…',1245],
'229712':['Plaque de montage M16 spéciale, pour une hauteur d’installation de…',1245],
'555305':['Télécommande, support mural compris, IP20, 42 canaux, noir, étiquetée…',185],
'555310':['Télécommande, support mural compris, IP20, 7 canaux, noir, étiquetée',155],
'555320':['Télécommande, support mural compris, IP20, 7 canaux, noir, étiquetée…',155],
'561300':['Motorisation pour Ambiente Nova, commande Pz200 incl.',1595],
'562200':['Commande Pz200 pour chauffages radiants, 3 × 400 V, telegris',1245],
'56220019':['Commande Pz200 pour chauffages radiants, 3 × 400 V, anthracite',1245],
'562201':['Option Pz200 pour 1 × 230 V (au lieu de 3 × 400 V) pour max. 2…',0],
'563100':['OSYRION Spot LED à batterie, jeu de 4, avec télécommande, chargeur inclus',265],
'564100':['Commande Pz200 pour chauffages radiants, 3 × 400 V, telegris',1195],
'56410019':['Commande Pz200 pour chauffages radiants, 3 × 400 V, anthracite',1195],
'564200':['Option Pz200 pour 1 × 230 V (au lieu de 3 × 400 V) pour max. 2…',0],
'564300':['Commande Pz200 pour moteur, 1 × 230 V, 10 A, telegris',675],
'56430019':['Commande Pz200 pour moteur, 1 × 230 V, 10 A, anthracite',675],
'564400':['Commande Pz200 pour chauffages radiants et moteur, 3 × 400V, telegris',1345],
'56440019':['Commande Pz200 pour chauffages radiants et moteur, 3 × 400V, anthracite',1345],
'565500':['Pack batterie, 14.4 V, 6.8 Ah, 100 Wh',495],
'570600':['Chauffage radiant (rayons infrarouges), aluminium poli, 1500 W, 230 V,…',315],
'570700':['Glatz raccord du chauffage radiant (incl. câble, 4 chauffages radiants…',49],
'609702':['Housse de protection ',95],
'609703':['5 pièces, housse de protection avec baguette et fermeture éclair',435],
'609704':['Housse de protection à Fortero Pro, 350 × 350 cm',155],
'609715':['Housse de protection 325 × 75 cm adaptée à la…',255],
'609725':['Housse de protection 400 × 85 cm adaptée à la…',285],
'609805':['Housse de protection 275 × 80 cm adaptée à la…',225],
'609815':['Housse de protection 325 × 90 cm adaptée à la…',255],
'609825':['Housse de protection 400 × 100 cm adaptée à la…',365],
'609835':['Housse de protection 480 × 110 cm adaptée à la…',415],
'609845':['Housse de protection 555 × 120 cm adaptée à la…',445],
'609974':['10 pièces, housse de protection avec baguette et fermeture éclair',675],
'900300':['Système de sanglage',165],
'900310':['Système de sanglage',165],
'900320':['Système de sanglage',165],
'900330':['Système de sanglage',165],
'900340':['Système de sanglage',165],
'906100':['Protection anti-chocs pour le mât du parasol, gris, amovible, H = 85 cm',295],
'906200':['Protection anti-chocs pour le mât du parasol, gris, amovible, H = 85 cm',335],
'906300':['Protection anti-chocs pour le mât du parasol, gris, amovible, H = 85 cm',345]
},h:{
'100500':'kit-de-roues-pour-socle-m4',
'100617':'couvercle-cache-pour-socle-m4-120kg-96-96-11-5cm',
'100630':'couvercle-cache-pour-socle-m4-120kg-96-96-11-5cm',
'100717':'couvercle-cache-pour-socle-m4-180kg-96-96-15cm',
'100730':'couvercle-cache-pour-socle-m4-180kg-96-96-15cm',
'100810':'socle-en-acier-z-40kg-acier-zingue-module-2024-tube-en-sus',
'100910':'socle-en-acier-z-55kg-acier-zingue-tube-en-sus',
'101000':'kit-de-roues-pour-socle-acier-z-40kg-55kg-acier-inoxydable',
'101001':'kit-de-roues-pour-socle-acier-z-40kg-55kg-acier-galvanise',
'108235':'socle-m4-cadre-120kg-pour-8-dalles-en-beton-40x40x4cm',
'108335':'socle-m4-cadre-180kg-pour-12-dalles-en-beton-40x40x4cm',
'109432':'socle-carre-en-granit-naturel-z-40kg-finition-mat',
'109434':'socle-carre-en-granit-naturel-z-55kg-finition-mat',
'109436':'socle-carre-en-granit-naturel-z-90kg-finition-mat',
'109438':'socle-en-granit-naturel-m4-120kg-finition-mat',
'109445':'socle-en-granit-naturel-z-55-kg-55-55-9cm-pierre-naturelle-avec-roulettes-et-poignee-telescopique-tube-en-sus',
'109447':'socle-en-granit-naturel-z-55-kg-pierre-naturelle',
'109465':'socle-en-granit-naturel-z-40-kg-45-45-8cm-pierre-naturelle-avec-roulettes-et-poignee-telescopique-tube-en-sus',
'109467':'socle-en-granit-naturel-z-40-kg-pierre-naturelle',
'109480':'demi-socle-en-granite-z-30kg-pierre-naturelle',
'109486':'kit-de-roues-pour-socle-granit-z-2025-acier-inoxydable',
'109487':'kit-de-roues-pour-socle-granit-z-40-55-90-m4-120-kg-2025-acier-galvanise',
'109495':'socle-en-granit-naturel-m4-120-kg-pierre-naturelle',
'109529':'socle-en-beton-z-40kg',
'110500':'kit-de-poids-4-pieces-env-90kg-pour-socle-a-roulettes-m4-120kg',
'110550':'recipients-pour-cadre-de-socle-a-roulettes-m4-90-120kg',
'110800':'kit-de-poids-4-pieces-env-150kg-pour-socle-a-roulettes-m4-180kg',
'111016':'socle-en-beton-clair-z-30kg-tube-en-sus',
'111116':'socle-en-beton-clair-z-40kg-tube-en-sus',
'111216':'socle-en-beton-clair-z-55kg-tube-en-sus',
'111316':'socle-en-beton-clair-z-70kg-tube-en-sus',
'111416':'socle-en-beton-clair-z-90kg-tube-en-sus',
'113200':'socle-a-roulettes-z-beton-55kg-cache-en-sus',
'113310':'plaque-decorative-pour-socle-a-roulettes-z-beton-55kg-1',
'113320':'plaque-decorative-pour-socle-a-roulettes-z-beton-55kg-1',
'113400':'socle-a-roulettes-z-beton-clair-90kg-plaque-decorative-non-incluse',
'113610':'cadre-pour-socle-a-roulettes-m4-120kg-kit-de-poids-et-cache-en-sus',
'113620':'cadre-pour-socle-a-roulettes-m4-120kg-kit-de-poids-et-cache-en-sus',
'113710':'plaque-decorative-pour-socle-a-roulettes-m4-120kg',
'113720':'plaque-decorative-pour-socle-a-roulettes-m4-120kg',
'113810':'cadre-pour-socle-a-roulettes-m4-180kg-kit-de-poids-et-cache-en-sus',
'113820':'cadre-pour-socle-a-roulettes-m4-180kg-kit-de-poids-et-cache-en-sus',
'113830':'cadre-pour-socle-a-roulettes-m4-180kg-kit-de-poids-et-cache-en-sus',
'113910':'plaque-decorative-pour-socle-a-roulettes-m4-180kg',
'113920':'plaque-decorative-pour-socle-a-roulettes-m4-180kg',
'113940':'plaque-decorative-pour-socle-a-roulettes-m4-180kg',
'114340':'plaque-decorative-pour-socle-a-roulettes-z-beton-55kg-1',
'200035':'tube-m4-o48-55mm-acier-zingue',
'200082':'tube-m4-o48-55mm-acier-zingue',
'200135':'tube-z-o25-33mm-en-acier-zingue',
'200235':'tube-m4-p-acier-zingue',
'201010':'tube-z-o35-38-39mm',
'201100':'tube-z-o35-38-39mm',
'201210':'tube-z-o48-55mm',
'201282':'tube-z-o48-55mm',
'201300':'tube-z-o48-55mm',
'201400':'tube-z-p',
'201500':'tube-z-p',
'201610':'tube-de-fixation-z-sur-socle-pour-twist',
'201710':'tube-de-fixation-z-sur-socle-pour-smart',
'201820':'tube-de-raccord-bt-pour-twist',
'201830':'tube-de-raccord-bt-pour-twist',
'201930':'tube-de-raccord-bt-pour-smart',
'205000':'console-murale-z-180mm-en-acier-zingue',
'205100':'tube-de-raccord-st-o25-33mm-acier-zingue',
'205105':'douille-a-betonner-st-acier-zingue',
'205400':'pointe-a-gazon-z-en-acier-zingue',
'206001':'tube-de-raccord-parasol-pendalex-o48-55mm',
'206011':'tube-de-raccord-parasol-pendalex-o48-55mm',
'206020':'tube-de-raccord-parasol-pendalex-p',
'206030':'tube-de-raccord-parasol-pendalex-p',
'206040':'tube-de-raccord-parasol-pendalex-p',
'206050':'tube-de-raccord-parasol-pendalex-p',
'206082':'tube-de-raccord-parasol-pendalex-o48-55mm',
'206100':'douille-a-betonner-bt-acier-zingue',
'206210':'tube-de-raccord-bt-o35-38-39mm-acier-zingue',
'207001':'douille-a-betonner-parasol-pendalex',
'207011':'douille-a-betonner-parasol-pendalex',
'220940':'fortano-pied-m4-fixe',
'220950':'fortano-pied-pivotant-m4',
'220960':'fortano-pied-m4-fixe',
'220970':'fortano-pied-pivotant-m4',
'221492':'housse-de-protection-pour-parasol-sombrano-o350-300x300cm',
'221502':'housse-de-protection-pour-parasol-sombrano-o400-400x300-350x350cm',
'221504':'housse-de-protection-pour-parasol-vita®-sfera-o375cm',
'221505':'housse-de-protection-pour-parasol-vita®-sfera-o300x300cm',
'221506':'housse-de-protection-pour-parasol-vita®-sfera-350x350cm-400x300cm',
'221800':'adaptateur-px-a-m4-fortello',
'225040':'charniere-de-montage-m8-palazzo-style',
'225045':'charniere-de-montage-m16-palazzo-royal',
'226000':'douille-a-betonner-m8-acier-zingue',
'226001':'douille-a-betonner-m16-acier-zingue',
'226510':'douille-a-betonner-m4-acier-zingue',
'226906':'set-de-12-dalles-en-beton-decor-granite-40x40x4cm-env-170kg',
'226907':'set-de-12-dalles-en-beton-40x40x4cm-env-165kg',
'226908':'set-de-8-dalles-en-beton-40x40x4cm-env-110kg',
'226909':'set-de-8-dalles-beton-decor-granite-40x40x4cm-env-115kg',
'226921':'plaque-de-montage-m4-m8-acier-zingue',
'226930':'plaque-de-montage-m4-speciale-pour-hauteur-150-350-mm',
'226932':'plaque-de-montage-m4-speciale-pour-hauteur-50-149-mm',
'226945':'socle-m4-m8-m16-cadre-240-690kg',
'226948':'set-de-8-dalles-en-beton-49x49x9-1cm-env-385kg',
'226950':'set-de-4-dalles-en-beton-48-3x48-3x9-4cm-env-192kg',
'226952':'set-de-4-dalles-en-beton-48-3x48-3x12-5cm-env-260kg',
'226954':'set-de-8-dalles-en-beton-48-3x48-3x25cm-env-250kg',
'226956':'set-de-8-dalles-en-beton-48-3x48-3x25cm-env-690kg',
'227040':'tube-m4-pallazzo',
'227080':'tube-m4-ambiente-nova',
'227300':'tube-m4-castello-pro',
'227417':'couvercle-cache-pour-socle-m4-m8-m16-240kg-110-110-12cm',
'227430':'couvercle-cache-pour-socle-m4-m8-m16-240kg-110-110-12cm',
'227517':'couvercle-cache-pour-socle-m4-m8-m16-310kg-110-110-15cm',
'227530':'couvercle-cache-pour-socle-m4-m8-m16-310kg-110-110-15cm',
'229405':'console-murale-m4-portee-480mm-acier-zingue',
'229410':'console-murale-m4-portee-100mm-acier-zingue',
'229701':'plaque-de-montage-m16-acier-zingue',
'252005':'bride-u-o31-40mm-acier-inoxydable',
'563000':'osyrion-spot-led-jeu-de-2-lampes-sans-fil-avec-telecommande-pour-parasol',
'563100':'osyrion-spot-led-jeu-de-4-lampes-sans-fil-avec-telecommande-pour-parasol',
'565500':'pack-batterie-pour-fortello-led-li-lon',
'570600':'chauffage-infrarouge-1500w-castello-pro',
'609701':'housse-de-protection-pour-parasol-fortello',
'609702':'housse-de-protection-pour-parasol-sunwing-casa',
'609704':'housse-de-protection-pour-parasol-fortero®-pro-350x350cm',
'609705':'housse-de-protection-pour-parasol-fortero®-pro',
'609715':'housse-de-protection-pour-parasol-castello-pro',
'609725':'housse-de-protection-pour-parasol-castello-pro-400x85cm',
'609800':'housse-de-protection-pour-parasol-piazza®',
'609805':'housse-de-protection-pour-parasol-palazzo®-style-275x80cm',
'609813':'housse-avec-fermeture-eclair-345x80cm-pour-parasol-ambiente',
'609814':'housse-avec-fermeture-eclair-345x80cm-pour-parasol-ambiente-1',
'609815':'housse-de-protection-pour-parasol-noblesse-style-325x90cm',
'609825':'housse-de-protection-pour-parasol-noblesse-style-400x100cm',
'609835':'housse-de-protection-pour-parasol-palazzo-royal-480x110cm',
'609845':'housse-de-protection-pour-parasol-palazzo-royal-555x120cm',
'609931':'housse-de-protection-parasol-pendalex-p',
'609979':'housse-de-protection-pour-parasol-teakwood',
'609980':'housse-de-protection-pour-parasol-alu-smart-twist-push-style-fortino',
'609983':'housse-de-protection-pour-parasol-alexo-siesta'
}};